import { createOpenAICompatible } from '@ai-sdk/openai-compatible';
import { createAuthorizationHeaderValue } from 'lib-shared-auth';
import { config } from 'lib-shared-backend-config';

const CHAT_COMPLETION_API = 'v4/ai/model';

/**
 * OpenAI-compatible provider that targets our gateway. See
 * https://ai-sdk.dev/providers/openai-compatible-providers for more details.
 */
export const dixaGateway = createOpenAICompatible({
  name: 'dixa-gateway',
  baseURL: `${config.url.rest}/${CHAT_COMPLETION_API}`,
  fetch: async (input, init) => {
    const authorization = await createAuthorizationHeaderValue();
    const headers = new Headers(init?.headers);
    headers.set('Authorization', authorization);
    return fetch(input, { ...init, headers });
  },
});
